/**
 * Funcionalitat de canvis de fons dels mapes
 * */
function addOpcionsFonsMapes() {

	addHtmlInterficieFonsMapes();

	/*
	jQuery('.div_gr3_fons div').on('click', function() {
		var fons = jQuery(this).attr('id');

		//$.publish('analyticsEvent',{event:['mapa', tipus_user+'fons', fons, 1]});

		if (fons == 'topoMap') {
			map.topoMap();
			jQuery("#colorMap").popover('hide');
		} else if (fons == 'topoMapGeo') {
			map.topoMapGeo();
			jQuery("#colorMap").popover('hide');
		}else if (fons == 'topoGrisMap') {
			map.topoGrisMap();
			jQuery("#colorMap").popover('hide');
		}else if (fons == 'ortoMap') {
			map.ortoMap();
			jQuery("#colorMap").popover('hide');
		}else if (fons == 'hibridMap') {
			map.hibridMap();
			jQuery("#colorMap").popover('hide');

		} else if (fons == 'colorMap') {
			gestionaPopOver(this);
		}

		if(fons == 'colorMap') {

			jQuery("#"+map.getActiveMap()).css('opacity','1');
			jQuery("#menu_init_fons div").each(function( index ) {
				jQuery(this).css('opacity','0.9');
				jQuery(this).css('border','0px solid #FFC500');
			});
		}else{

			jQuery(".div_gr3_fons div").each(function( index ) {
				jQuery(this).css('opacity','0.9');
				jQuery(this).css('border','0px solid #FFC500');
			});
		}

		jQuery(this).css('opacity','1');

	});
	*/
}


function creaPopOverMesFons() {

}

function creaPopOverMesFonsColor() {
	jQuery("#colorMap")
	.popover(
	{
		content : '<div id="div_menufons" class="div_gr3_fons">'
			+ '<div id="naturalMap" lang="ca" data-toggle="tooltip" title="Outdoor" data-lang-title="Outdoor" class="div_fons_17"></div>'
			+ '<div id="topoGrisMap" lang="ca" data-toggle="tooltip" title="Simple gris" data-lang-title="Simple gris" class="div_fons_2"></div>'
			+ '<div id="sepia" lang="ca" data-toggle="tooltip" title="Sèpia" data-lang-title="Sèpia" class="div_fons_7"></div>'
			+ '<div id="orquidea" lang="ca" data-toggle="tooltip" title="Orquídea" data-lang-title="Blue print" class="div_fons_9"></div>'
			+ '<div id="terrainMap" lang="ca" data-toggle="tooltip" title="Terreny" data-lang-title="Terreny" class="div_fons_4"></div>'
			+ '<div id="zombie" lang="ca" data-toggle="tooltip" title="Zombie" data-lang-title="Coure" class="div_fons_8"></div>'
			+ '<div id="historicOrtoMap" lang="ca" data-toggle="tooltip" title="Ortoimatge 19567" data-lang-title="Ortoimatge 1956" class="div_fons_11"></div>'
			+ '<div id="historicOrtoMap46" lang="ca" data-toggle="tooltip" title="Ortoimatge 1946" data-lang-title="Ortoimatge 1946" class="div_fons_14"></div>'
			+ '<div id="nit" lang="ca" data-toggle="tooltip" title="Nit" data-lang-title="Nit" class="div_fons_6"></div>'
			+ '<div id="historicMap" lang="ca" data-toggle="tooltip" title="Mapa històric Catalunya 1936" data-lang-title="Mapa històric Catalunya 1936" class="div_fons_10"></div>'
			+ '<div id="alcadaMap" lang="ca" data-toggle="tooltip" title="Model d\'elevacions" data-lang-title="Model d\'elevacions" class="div_fons_15"></div>'
			+ '<div id="divadminMap" lang="ca" data-toggle="tooltip" title="Divisions administratives" data-lang-title="Divisions administratives" class="div_fons_16"></div>'
			+ '<div id="hibridTerrainMap" lang="ca" data-toggle="tooltip" title="Terreny hibrid" data-lang-title="Terreny hibrid" class="div_fons_18"></div>'
			+ '<div id="colorBlankMapwhite" lang="ca" data-toggle="tooltip" title="Fons blanc" data-lang-title="Fons neutre blanc" class="div_fons_blank"></div>'
			+ '<div id="colorBlankMaplightgray" lang="ca" data-toggle="tooltip" title="Fons blanc" data-lang-title="Fons neutre gris" class="div_fons_gris"></div>'
			+ '<div id="colorBlankMapgray" lang="ca" data-toggle="tooltip" title="Fons blanc" data-lang-title="Fons neutre gris fort" class="div_fons_gris_fort"></div>'
			+ '</div>',
		container : 'body',
		html : true,
		trigger : 'manual',
		selector: '[rel="popover"]'
	});

	jQuery("#colorMap").on('show.bs.popover',function(){
		jQuery(this).attr('data-original-title','');
	});

	// please note, that IE11 now returns undefined again for window.chrome
	var isChromium = window.chrome,
	    vendorName = window.navigator.vendor;

	jQuery("#colorMap").on('click',function(e){
		jQuery('#div_menufons [data-toggle="tooltip"]').tooltip({
			placement : 'top',
			container : 'body'
		});

		$('.popover:not(.in)').hide().detach();

		if(isChromium !== null && isChromium !== undefined && vendorName === "Google Inc.") {
			// is Google chrome
		  	jQuery(".popover").css('height','195px');
		  	jQuery(".popover").css('width','200px');
		} else {
			jQuery(".popover").css('height','190px');
			jQuery(".popover").css('width','190px');
		}

		jQuery(".popover").css('background-color','rgba(60, 62, 54, 0.9)');
		jQuery(".popover").css('z-index','1000');
	});

	jQuery(document).on('click', "#menu_init_fons div", function(e) {
		jQuery('#div_menufons [data-toggle="tooltip"]').tooltip('hide');
		var fons = jQuery(this).attr('id');
		//$.publish('analyticsEvent',{event:['mapa', tipus_user+'fons', fons, 1]});

		if(fons){
			map.changeBackgroundType(fons);
			/*
			if (fons == 'topoMap') {
				map.topoMap();
			} else if (fons == 'topoMapGeo') {
				map.topoMapGeo();
			}else if (fons == 'topoGrisMap') {
				map.topoGrisMap();
			}else if (fons == 'ortoMap') {
				map.ortoMap();
			}else if (fons == 'hibridMap') {
				map.hibridMap();
			}else if (fons == 'topoGrisMap') {
				map.topoGrisMap();
			}else if (fons == 'historicOrtoMap') {
				map.historicOrtoMap();
			}else if (fons == 'historicMap') {
				map.historicMap();
			} else if (fons == 'terrainMap') {
				map.terrainMap();
			}else if (fons == 'historicOrtoMap46') {
				map.historicOrtoMap46();
			}else if (fons == 'alcadaMap') {
				map.alcadaMap();
			}else if (fons == 'naturalMap') {
				map.naturalMap();
			}else if (fons == 'divadminMap') {
				map.divadminMap();
			}else if (fons == 'hibridTerrainMap') {
				map.hibridTerrainMap();
			}else if (fons.indexOf('colorBlankMap')!=-1) {
				map.colorBlankMap(fons);
			}else{
				map.colorMap(fons);
				jQuery("#colorMap").popover('hide');
			}
			*/
		}

		jQuery("#div_menufons div").each(function( index ) {
			jQuery(this).css('opacity','0.7');
		});
		jQuery(this).css('opacity','1');
		jQuery("#colorMap").css('opacity','1');

	});
}

function getFonslistHtml(){
	var fontList = '<div class="add_costat_r2">'
	+'</div>'
	+'<div id="menu_init_fons" class="div_gr3_fons">'
	+ '<div id="euroRegioFons" class="subitem hidden">'
	+ '	<div id="topoEuroRegio" class="map-background truncate" lang="ca" style="background-image: url(\'/static/img/map-backgrounds/euro_regio.jpg\');">'
	+ '		EuroRegio'
	+ '	</div>'
	+ '</div>'
	+ '<div class="subitem">'
	+ '	<div id="topoMapGeo" class="map-background truncate" lang="ca" style="background-image: url(\'/static/img/map-backgrounds/Simple_12228.jpg\');">'
	+ '		Simple'
	+ '	</div>'
	+ '</div>'
	+ '<div class="subitem">'
	+ '	<div id="topoGrisMap" class="map-background truncate" lang="ca" style="background-image: url(\'/static/img/map-backgrounds/topografic_gris_12228.jpg\');">'
	+ '		Simple gris'
	+ '	</div>'
	+ '</div>'
	+ '<div class="subitem">'
	+ '	<div id="topoMap" class="map-background truncate" lang="ca" style="background-image: url(\'/static/img/map-backgrounds/topo_ICGC.jpg\');">'
	+ '		Topogràfic'
	+ '	</div>'
	+ '</div>'
	+ '<div class="subitem">'
	+ '	<div id="hibridMap" class="map-background truncate" lang="ca" style="background-image: url(\'/static/img/map-backgrounds/Orto_hibrida_12228.jpg\');">'
	+ ' 	Mapa híbrid'
	+ '	</div>'
	+ '</div>'
	+ '<div class="subitem">'
	+ ' <div id="ortoMap" class="map-background truncate" lang="ca" style="background-image: url(\'/static/img/map-backgrounds/orto.jpg\');">'
	+ '		Imatge'
	+ '	</div>'
	+ ' </div>'
	+ '<div class="subitem">'
	+ '	<div id="fonsGeologic" class="map-background truncate" lang="ca" style="background-image: url(\'/static/img/map-backgrounds/fons_geologic.png\');">'
	+ '		Geològic'
	+ '	</div>'
	+ '</div>'
	+ '<div class="subitem">'
	+ '	<div id="divadminMap" class="map-background truncate" lang="ca" style="background-image: url(\'/static/img/map-backgrounds/Divisions_administratives_763.jpg\');">'
	+ '		Divisions administratives'
	+ '	</div>'
	+ '</div>'
	+ '<div class="subitem">'	
	+ '	<div id="hibridTerrainMap" class="map-background truncate" lang="ca" style="background-image: url(\'/static/img/map-backgrounds/Terreny_hibrid_12228.jpg\');">'
	+ '		Terreny híbrid'
	+ '	</div>'
	+ '</div>'
	+ '<div class="subitem">'
	+ '	<div id="naturalMap" class="map-background truncate" lang="ca" style="background-image: url(\'/static/img/map-backgrounds/Natural_12228.jpg\');">'
	+ '		Outdoor'
	+ '	</div>'
	+ '</div>'
	+ '<div class="subitem">'
	+ '	<div id="orquidea" class="map-background truncate" lang="ca" style="background-image: url(\'/static/img/map-backgrounds/blue_print_12228.jpg\');">'
	+ '		BluePrint'
	+ '	</div>'
	+ '</div>'
	+ '<div class="subitem">'
	+ '	<div id="nit" class="map-background truncate" lang="ca" style="background-image: url(\'/static/img/map-backgrounds/Nit_12228.jpg\');">'
	+ '		Nit'
	+ '	</div>'
	+ '</div>'
	+ '<div class="subitem">'
	+ '	<div id="sepia" class="map-background truncate" lang="ca" style="background-image: url(\'/static/img/map-backgrounds/Sepia_12228.jpg\');">'
	+ '		Sèpia'
	+ '	</div>'
	+ '</div>'
	+ '<div class="subitem">'
	+ '	<div id="zombie" class="map-background truncate" lang="ca" style="background-image: url(\'/static/img/map-backgrounds/Coure_12228.jpg\');">'
	+ '		Coure'
	+ '	</div>'
	+ '</div>'
	+ '<div class="subitem">'
	+ '	<div id="colorBlankMapwhite" class="map-background truncate" lang="ca" style="background-image: url(\'/static/img/map-backgrounds/blanc.png\');">'
	+ '		Fons neutre blanc'
	+ '	</div>'
	+ '</div>'
	+ '<div class="subitem">'
	+ '	<div id="colorBlankMaplightgray"  class="map-background truncate" lang="ca" style="background-image: url(\'/static/img/map-backgrounds/gris.jpg\');">'
	+ '		Fons neutre gris'
	+ '	</div>'
	+ '</div>'
	+ '<div class="subitem">'
	+ '	<div id="colorBlankMapgray" class="map-background truncate" lang="ca" style="background-image: url(\'/static/img/map-backgrounds/gris_fort.jpg\');">'
	+ '		Fons neutre gris fort'
	+ '	</div>'
	+ '</div>'
	+ '<div class="subitem">'
	+ '	<div id="historicOrtoMap46" class="map-background truncate" lang="ca" style="background-image: url(\'/static/img/map-backgrounds/Historica_46_12228.jpg\');">'
	+ '		Ortoimatge 1946'
	+ '	</div>'
	+ '</div>'
	+ '<div class="subitem">'
	+ '	<div id="historicOrtoMap" class="map-background truncate" lang="ca" style="background-image: url(\'/static/img/map-backgrounds/Historica_56_12228.jpg\');">'
	+ '		Ortoimatge 1956'
	+ '	</div>'
	+ '</div>'
	+ '<div class="subitem">'
	+ '	<div id="terrainMap" class="map-background truncate" lang="ca" style="background-image: url(\'/static/img/map-backgrounds/Terreny_12228.jpg\');">'
	+ '		Terreny'
	+ '	</div>'
	+ '</div>'
	+ '</div>';
	return fontList;
}

function addHtmlInterficieFonsMapes(){


	jQuery("#funcio_fonsMapes").append(getFonslistHtml());

	$('.div_gr3_fons [data-toggle="tooltip"]').tooltip({placement : 'bottom',container : 'body'});

	jQuery(".div_gr3_fons div").each(function( index ) {
		jQuery(this).css('opacity','0.7');
		jQuery(this).css('border','0px solid #FFC500');
	});

	/*
	var mAct=map.getActiveMap();
	jQuery("#"+mAct).css('opacity','1');
	if(mAct.indexOf('topoMap')==-1 &&mAct.indexOf('topoMapGeo')==-1 && mAct.indexOf('ortoMap')==-1 && mAct.indexOf('ortoAugmentada')==-1 && mAct.indexOf('hibridMap')==-1){
		jQuery("#colorMap").css('opacity','1');
	}
	*/

}
